import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { toast } from "react-toastify";

const AddCourseLink = ({ updateCourseLink, existingLinks }) => {
    useEffect(() => {
        if (existingLinks && existingLinks.length > 0) {
            const formattedLinks = existingLinks.map((url, index) => ({
                id: Date.now() + index,
                url: url
            }));
            setLinks(formattedLinks);
        } else {
            setLinks([{ id: Date.now(), url: "" }]);
        }
    }, [existingLinks]);

    const [links, setLinks] = useState([{ id: 1, url: "" }]);

    const addLink = () => {
        if (links.length < 10) {
            setLinks([...links, { id: Date.now(), url: "" }]);
        }
    };

    const removeLink = (id) => {
        if (links.length > 1) {
            setLinks(links.filter(link => link.id !== id));
        } else {
             // If it's the last one, just clear the value
             setLinks(links.map(link => link.id === id ? { ...link, url: "" } : link));
        }
    };

    const updateLink = (id, url) => {
        setLinks(links.map(link => link.id === id ? { ...link, url } : link));
    };

    const isValidUrl = (urlString) => {
        var urlPattern = new RegExp('^(https?:\\/\\/)?' + // validate protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // validate fragment locator
        return !!urlPattern.test(urlString);
    }

    const handleSubmit = () => {
        const nonEmptyLinks = links.filter(link => link.url.trim() !== "");
        
        // Validate URLs
        const invalidLinks = nonEmptyLinks.filter(link => !isValidUrl(link.url));
        if (invalidLinks.length > 0) {
            toast.error("Please enter valid URLs (e.g., https://example.com)");
            return;
        }

        const courseLinks = nonEmptyLinks.map(link => link.url);
        updateCourseLink(courseLinks);
    };

    return (
        <div className="card">
            <h3>Course Links</h3>
            {links.map((link, index) => (
                <div key={link.id} className="flex align-items-center mb-3">
                    <InputText
                        value={link.url}
                        onChange={(e) => updateLink(link.id, e.target.value)}
                        placeholder={`Course Link ${index + 1}`}
                        className="flex-1 mr-2"
                    />
                    {links.length > 1 && (
                        <Button
                            icon="pi pi-minus"
                            className="p-button-sm mr-2"
                            onClick={() => removeLink(link.id)}
                        />
                    )}
                    {index === links.length - 1 && links.length < 10 && (
                        <Button
                            icon="pi pi-plus"
                            className="p-button-sm ml-0"
                            onClick={addLink}
                        />
                    )}
                </div>
            ))}
            <Button
                label="Submit Course Links"
                className="p-button-primary mt-3 ml-0"
                onClick={handleSubmit}
            />
        </div>
    );
};

export default AddCourseLink;
